import React from 'react';

export default function() {
  if (window.opener) {
    window.opener.postMessage('getUser', window.origin);
  }
  Office.context.ui.messageParent('getUser');
  return <div>Login Success</div>;
}
